// Temporary place to put config/global values that we need access to in multiple places
export const OFFERS_PREFIX = "lobby/offers";
export const GAMES_PREFIX = "games";
